import React from 'react'
import styled from '@emotion/styled'
import { FullWidth } from '../Misc/FullWidth'
import { storyTypography } from '../../../tokens/typography-storybuilder'

type Props = {
  /**
   * The title string
   */
  title: string
  /**
   * color to apply to full-width of title block
   */
  backgroundColor?: string
}

/**
 * TitleBlockPublic Component
 *
 * Block for the Title of the story, with optional background color.
 *
 * @param {Props} props - The component props.
 * @returns {JSX.Element} - A React functional component representing the StoryHeader.
 */
export const TitleBlockPublic = ({
  title,
  backgroundColor,
}: Props): JSX.Element | null => {
  if (title === '' || title === null) {
    return null
  }

  return (
    <FullWidth backgroundColor={backgroundColor}>
      <Title>{title}</Title>
    </FullWidth>
  )
}

const Title = styled('h1')`
  ${storyTypography.h1};
  text-align: left;
  margin: 0 auto;
  max-width: 672px;
`
